
function doBackground() {

    let canvas = document.getElementById("background") as HTMLCanvasElement;
    if (!canvas) {
        canvas = document.createElement("canvas");
        canvas.id = "background";
        document.body.appendChild(canvas);
        console.log("canvas created");
    }
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const ctx = canvas.getContext("2d", { alpha: false });
    if (!ctx) {
        console.error("Unable to get canvas 2d-context");
        return;
    }

    ctx.imageSmoothingEnabled = true;

    //window.requestAnimationFrame(() => {
    const grd = ctx.createLinearGradient(0, 0, 50, canvas.height);
    grd.addColorStop(1, "#0079be");
    grd.addColorStop(0, "#00b0e0");
    ctx.fillStyle = grd;
    ctx.rect(0, 0, canvas.width, canvas.height);
    ctx.fill();

    ctx.fillStyle = "rgba(255,255,2500,0.1)";

    const size = 10;
    for (let y = 0; y < canvas.height; y += size)
        for (let x = 0; x < canvas.width; x += size) {
            let r = (Math.sin(x / canvas.width * Math.PI + Math.sin(y / canvas.height * Math.PI * 2 - 0.5))) * 4;
            if (r > 0) {
                ctx.beginPath();
                ctx.arc(x + (size / 2), y + (size / 2), r, 0, 2 * Math.PI);
                ctx.fill();
            }
        }

    //});
}

var updateTimer = 0;

function resizeListener() {
    clearTimeout(updateTimer);
    updateTimer = window.setTimeout(doBackground, 100);
}

export function setupBackgound() {
    //window.addEventListener("load", doBackground);
    window.addEventListener("resize", resizeListener);
    doBackground();
}

export function removeBackground() {
    window.removeEventListener("resize", resizeListener);

    const canvas = document.getElementById("background") as HTMLCanvasElement;
    if (canvas) {
        canvas.remove();
    }
}

